export class CityService {
  constructor($http) {
    this.http = $http;
  }

  getCitiesList(){
    return this.http.get('/api/city');
  }
}
